import { ERRORS_DATA } from '../actions/actionType'

const initialState = {
  errors: [],
}

export default function ErrorsReducer(state = initialState, action) {
  switch (action.type) {
    case ERRORS_DATA:
      return { ...state, errors: action.payload }
    default:
      return state
  }
}
